export default[
    {
        path: '/dataList/repairData',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '档案数据',
            authLogin: true
        }
    }
]